module.exports = __webpack_public_path__ + "img/hoantat.b4d49071.png";